export default "__VITE_ASSET__CjxlLwT7__"